import {Button, Modal} from "semantic-ui-react";
import React from "react";
import {escapeEmptyDetail} from "../../utils/utils";
import StripedTable from "../Table/StripedTable";


const roleData = [
    {
        role: 'Program Developer (PD)',
        description:
            'Entity that develops the SMART Program requirements including determining the required stakeholder roles and associated requirements related to accreditation and expertise, data requirements, contextualization steps, and desired outputs including but not limited to outcomes / KPIs, certificates, and/or  tokens / assets.'
    },
    {
        role: 'Protocol Implementer (PI)',
        description:
            'Entity that interprets and defines how the relevant protocol will be administered and incorporated into the Program in accordance with industry standards, principles, best practices, and any applicable laws, and confirms that the relevant protocol is appropriately integrated with SMART data architecture. This includes, for example, evaluating the relevant protocol for requirements related to robust and transparent validation and verification procedures and remaining apprised of any protocol updates and ensuring that any needed adjustments are made to the SMART data architecture.'
    },
    {
        role: 'Primary Asset Data Provider (PADP)',
        description:
            'Title holder to the underlying project, activity, or physical asset that is the focus of the Program and the source of primary data generated by, and reflecting the physical attributes of, the project and/or physical asset, which are used as inputs for the protocol(s).'
    },
    {
        role: 'Data Aggregator Pre-Processor (DAPP)',
        description:
            'Entity that provides data processing services to enable raw data inputs from the project and physical asset, and potentially secondary data provider(s), to be organized into data payloads that can be processed through a protocol to generate Program outcomes. This can include, for example, performing quality control checks, as appropriate, to ensure and attest to completeness, accuracy, and integrity of data payloads.'
    },
    {
        role: 'Independent Verifier (IV)',
        description:
            'Entity that provides verification services to the Program required by Program rules and/or the protocol, including verification of primary and secondary data sets, data payloads, and/or the Program outcomes. Services may include attestation on the validity and completeness of relevant data inputs and the materiality of any identified data gaps or discrepancies, and verification that outcomes adhere to industry best practices and established third-party standards.'
    },
    {
        role: 'Quality Assurance Provider (QAP)',
        description:
            'Provides external assurance relating to procedures and processes associated with the Program to confirm adherence to relevant laws and rules governing the Program.'
    },
    {
        role: 'Outcome Subscriber (OS)',
        description:
            'Entity that licenses the use of the outcomes of a Program and/or purchases the environmental assets resulting from a Program. An Outcome Subscriber may play one or more other roles in a Program (e.g., Primary Asset Data Provider), or it may be an entity not playing another Program role. For example, a data intermediary that publishes, distributes, or re-packages data and calculated metrics for third-party subscribers or regulatory agencies'
    },
    {
        role: 'Registry Provider (RP)',
        description:
            'Entity that provides the digital infrastructure for storing, transferring, and retiring environmental assets derived from the underlying project, activity, or physical asset that is the subject of the Program.'
    },
    {
        role: 'Environmental Asset Issuer (EAI)',
        description:
            'Entity responsible for conducting assessments and making registry issuance determinations on environmental assets derived from the underlying project, activity, or physical asset that is the subject of the Program.'
    },
    {
        role: 'Secondary Data Provider (SDP)',
        description:
            'Third party that provides additional, original data used to supplement, enhance, and/or put into context the primary data provided to the Program that can include satellite, ground-level, airborne, and other monitoring systems.'
    },
    {
        role: 'Program Design Advisor(s) (PDA)',
        description:
            'Entity that provides input to the Program Developer to inform program requirements, including those related to stakeholder roles, data, contextualization, and outputs. PDAs typically provide Program-specific subject matter expertise needed to ensure the Program meets the objectives of Program participants.'
    }
]

const StakeholderInfoModal = (props) => {

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
            className='formModal'
        >
            <Modal.Header>Stakeholders</Modal.Header>
            <Modal.Content className='formModal-content'>
                <StripedTable
                    aria-label='simple table'
                    headings={['Role', 'Description']}
                    rows={roleData?.map((data, index) => {
                        if (data) {
                            return {
                                elements: [
                                    <p>{escapeEmptyDetail(data.role)}</p>,
                                    <p>{escapeEmptyDetail(data.description)}</p>],
                            };
                        } else {
                            return {
                                elements: [],
                            };
                        }
                    })}
                ></StripedTable>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={props.onClose}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

export default StakeholderInfoModal;
